import { DISABLED_UNTIL_JS_READY_DATA_ATTR_NAME } from "../shared/constants/elementEnabler";

/**
 * Enables all elements that are waiting for entrypoints from vite.
 * Elements are identified by the data attribute 'disabled-until-js-ready'.
 */
export const enableAllElementsWaitingForJs = () => {
  const elementsForEnable: NodeListOf<HTMLButtonElement> = document.querySelectorAll(
    `[${DISABLED_UNTIL_JS_READY_DATA_ATTR_NAME}]`
  );
  elementsForEnable.forEach(button => {
    enableHTMLElement(button);
  });
};

const enableHTMLElement = (element: HTMLButtonElement) => {
  element.removeAttribute(DISABLED_UNTIL_JS_READY_DATA_ATTR_NAME);
  element.removeAttribute("disabled");
};
